import React from 'react';
import PropTypes from 'prop-types';
import { Container as SemanticContainer } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import prettybytes from 'pretty-bytes';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';

/**
 * ProjectHeader component class.
 * @function ProjectHeader
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const ProjectHeader = ({ content, showImage }) => {
  showImage = showImage || false;
  const intl = useIntl();
  const Image = config.getComponent({ name: 'Image' }).component;
  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;

  return (
    <div className="project-header">
      <div className="project-text-image-wrapper">
        <div className="project-text">
          <div className="project-suffix-heading">
            {content?.subjects?.map((subject) => (
              <span key={subject}>{subject} </span>
            ))}
          </div>
          {content?.project_end &&
            new Date(content.project_end) < new Date() && (
              <p className="project-end">
                <FormattedMessage
                  id="project_end"
                  defaultMessage="This project ended on {date}."
                  values={{
                    date: new Date(content.project_end).toLocaleDateString(
                      intl.locale,
                    ),
                  }}
                />
              </p>
            )}
          <h1 className="documentFirstHeading project-name-heading">
            {content.title}
          </h1>
          {content?.description && (
            <p className="project-description">{content.description}</p>
          )}
        </div>
        {showImage && content?.image?.download && (
          <div className="project-image">
            <a href={flattenToAppURL(content.image.download)}>
              <Image
                item={content}
                imageField="image"
                alt={content.title}
                responsive={true}
                description="test"
              />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
ProjectHeader.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    portrait: PropTypes.shape({
      scales: PropTypes.shape({
        preview: PropTypes.shape({
          download: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

export default ProjectHeader;
